import * as React from "react";
import { observer } from "mobx-react";
import { Loader } from "sb-resp-ui";

import "./LeagueListPresenter.less"

// imported only for typings
// these are passed to the component from index.ts
import { BaseDict } from "../dict";
import { LeagueListPresenterState } from "../state";
import * as CMP from "../components";
import { CouponButtonPosition } from "../../../Typings";

// external components
// import * as CMP from "../components";

/*
    Setup testing tools for MobX
    uncomment the <DevTools /> at the end of the LeagueListPresenter component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }

export type LeagueListPresenterProps = {
    dataProvider: LeagueListPresenterState
    dict: BaseDict
}

@observer
export class LeagueListPresenter extends React.Component<LeagueListPresenterProps, {
    dataProvider: LeagueListPresenterState
}> {
    dict: BaseDict
    refEl: React.RefObject<HTMLDivElement>;
    constructor(props: LeagueListPresenterProps) {
        super(props);

        // setup dictionary
        this.dict = props.dict;
        this.refEl = React.createRef();
        // setup data provider
        this.state = {
            dataProvider: props.dataProvider
        };
    }

    /* istanbul ignore next */
    renderLeagues(sportId: string, view: any[]) {
        return <div className="rj-league-list" ref={this.refEl}>
            <CMP.SportHeader label={this.dict[this.props.dataProvider.options.cms.headerPhrase]}>
                {this.state.dataProvider.options.cms.isCouponCreationEnabled &&
                    this.state.dataProvider.selectedLeagues.length ?
                    <CMP.CreateCouponBtn
                        sportId={sportId}
                        onClick={this.state.dataProvider.openCouponTranspiler}
                        label={this.dict.CreateCoupon}
                        count={this.state.dataProvider.selectedLeagues.length}
                        parentRef={this.refEl}
                        cuponPosition={this.props.dataProvider.options.cms.couponButtonPosition}
                        wrapEl={this.props.dataProvider.options.navHandler.centerPanelHolder.element}
                        tabletTopOffSet={this.props.dataProvider.options.navHandler.topPanelsHolder.element.getBoundingClientRect().height}
                        deviceType={this.props.dataProvider.deviceDetect}
                    /> : ""
                }
            </CMP.SportHeader>

            <div className="rj-league-list__content" data-uat="div-league-list-content">
                {view}
            </div>

            {this.props.dataProvider.options.cms.couponButtonPosition === CouponButtonPosition.Static
                && this.state.dataProvider.showBottomButton &&
                <CMP.CreateCouponBtn
                    sportId={sportId}
                    onClick={this.state.dataProvider.openCouponTranspiler}
                    label={this.dict.CreateCoupon}
                    count={this.state.dataProvider.selectedLeagues.length}
                    parentRef={this.refEl}
                    cuponPosition={this.props.dataProvider.options.cms.couponButtonPosition}
                    wrapEl={this.props.dataProvider.options.navHandler.centerPanelHolder.element}
                    tabletTopOffSet={this.props.dataProvider.options.navHandler.topPanelsHolder.element.getBoundingClientRect().height}
                    deviceType={this.props.dataProvider.deviceDetect}
                />
            }

            {this.state.dataProvider.leagues.length > this.state.dataProvider.numberOfAllLeaguesShownByDefault &&
                <CMP.ShowAllBtn
                    onClick={this.state.dataProvider.showAllButtonHandler}
                    expanded={this.state.dataProvider.showAllButton.expanded}
                    label={this.state.dataProvider.showAllButton.label}
                />
            }

            {/* {process.env.NODE_ENV === "development" && (
                <DevTools />
            )} */}
        </div>
    }

    /* istanbul ignore next */
    render() {
        /*
            How to use the dataProvider can be seen in an example here:
            https://confluence.sbtech.com/display/FR/React+LeagueListPresenter+Example
        */
        let view: any[] = [];
        let sportId = this.state.dataProvider.sportId;

        this.state.dataProvider.leagues.slice(0, this.state.dataProvider.getNumberOfLeaguesToRender).map(league => {
            if (league.id) {
                view.push(
                    <CMP.LeagueItem
                        key={`LeagueItem-${league.id}`}
                        league={league}
                        showCheckbox={this.state.dataProvider.options.cms.isCouponCreationEnabled}
                        toggleSelectedLeague={this.state.dataProvider.toggleSelectedLeague.bind(this.state, league.id)}
                        openLeagueTranspiler={this.state.dataProvider.openLeagueTranspiler}
                        tooltipMessage={this.dict.SelectedLeaguesLimitReached}
                        showTooltip={this.state.dataProvider.selectedLeaguesLimitReached}
                        selectedLeagueId={this.state.dataProvider.currentlySelectedLeague}
                        dict={this.dict}
                    />
                )
            }
        })

        return (
            this.state.dataProvider.isDataLoaded ?
                this.state.dataProvider.leagues.length > 0 && this.renderLeagues(sportId, view) :
                <div className="rj-league-list" data-uat="div-league-list-loader"><Loader /></div>
        )
    }
}
